import { render, staticRenderFns } from "./PaymentPending.vue?vue&type=template&id=66010bc4&"
import script from "./PaymentPending.vue?vue&type=script&lang=js&"
export * from "./PaymentPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports